<div class="header home-header" [ngClass]="{ 'sticky': isSticky }" id="header"> 
    <div class="w-100">
        <div class="d-flex justify-content-between">
            <div class="logo logo-dark">
                <a href="">
                    <img src="assets/images/logo/logo.png" alt="Logo">
                    <img class="logo-fold" src="assets/images/logo/logo-fold.png" alt="Logo">
                </a>
            </div>

            <div class="nav-wrap">
                <ul class="nav-left left" [ngClass]="{ 'expanded': isExpand }">
                    <!-- Home Link -->
                    <li>
                        <a routerLink="/home" 
                           routerLinkActive="active" 
                           [routerLinkActiveOptions]="{ exact: true }">Home</a>
                    </li>
                    <!-- About Link -->
                    <li>
                        <a routerLink="/about" 
                           routerLinkActive="active" 
                           [routerLinkActiveOptions]="{ exact: true }">About</a>
                    </li>
                    <li>
                        <a routerLink="/about" 
                           routerLinkActive="active" 
                           [routerLinkActiveOptions]="{ exact: true }">Services</a>
                    </li>
                    <li>
                        <a routerLink="/about" 
                           routerLinkActive="active" 
                           [routerLinkActiveOptions]="{ exact: true }">Prices</a>
                    </li>
                    <!-- Contact Link -->
                    <li>
                        <a routerLink="/contact" 
                           routerLinkActive="active" 
                           [routerLinkActiveOptions]="{ exact: true }">Contact Us</a>
                    </li>
                    <!-- Optional Mobile Toggle -->
                  
                </ul>
                <ul class="nav-right">
                   

                        <li class="mobile-toggle">
                            <a (click)="toggleExpand()">
                                <i nz-icon [nzType]="isExpand ? 'menu-fold' : 'menu-unfold'" theme="outline"></i>
                            </a>
                        </li>

                      <li>
                        <a href="dashboard" class="pr-0"> 
                            <button class="btn-blue">Start Tracking</button>
                        </a>
                      </li> 
                </ul>
            </div>
        </div>
    </div>
</div>
